import PropTypes from "prop-types";

export const GroupParticipantPropTypes = {
    participant: PropTypes.shape({
        name: PropTypes.string,
        uid: PropTypes.string,
    }),
    itemsCount: PropTypes.number,
};
